var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 61,
    viewBox: "0 0 184 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 -6)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Where_You_Wear_Your_Own_Imaginations",
    "data-name": "Where You Wear Your Own Imaginations",
    transform: "translate(0 65)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Ubuntu"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Where You Wear Your Own Imaginations")), /*#__PURE__*/React.createElement("text", {
    id: "Shafaq_waqas",
    "data-name": "Shafaq waqas",
    transform: "translate(92 52)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Ubuntu-Medium, Ubuntu",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -42,
    y: 0
  }, "SHAFAQ WAQAS")), /*#__PURE__*/React.createElement("text", {
    id: "SW",
    transform: "translate(50 37)",
    fill: "#fff",
    fontSize: 36,
    fontFamily: "EdwardianScriptITC, Edwardian Script ITC"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SW")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-logo.4d93258b5cac8d3adffcbc6fb98763e6.svg";
export { ForwardRef as ReactComponent };